'use client'

import { useServerInsertedHTML } from 'next/navigation'
import { getCssText } from '../config'

export function ServerStylesheet({ children }) {
  useServerInsertedHTML(() => {
    return (
      <style id="stitches" dangerouslySetInnerHTML={{ __html: getCssText() }} />
    )
  })

  return children
}
